import React from "react";
import { Users } from "lucide-react";
import { VEHICLES } from "../lib/api";

export default function VehicleShowcase() {
  const fleet = [...VEHICLES, ...VEHICLES];

  return (
    <section
      id="fleet"
      className="relative bg-black py-16 sm:py-24 lg:py-32 border-t border-white/5 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-5 sm:px-6 lg:px-12 mb-10 sm:mb-12">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-5">
          <div>
            <span className="text-[10px] tracking-[0.3em] uppercase text-[#FFC300] font-bold">
              02 · Fleet
            </span>
            <h2 className="mt-4 font-display text-3xl sm:text-4xl lg:text-6xl font-black uppercase tracking-tighter leading-none">
              Pick Your <span className="text-[#FFC300]">Vehicle</span>
            </h2>
          </div>
          <p className="text-neutral-400 max-w-md text-sm leading-relaxed">
            From economy hybrids to luxury vans — every vehicle in our fleet is professionally
            maintained and driven by licensed Barcelona locals.
          </p>
        </div>
      </div>

      {/* Marquee */}
      <div className="relative">
        <div className="absolute left-0 top-0 bottom-0 w-16 sm:w-32 bg-gradient-to-r from-black to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-16 sm:w-32 bg-gradient-to-l from-black to-transparent z-10 pointer-events-none" />

        <div
          className="flex gap-3 sm:gap-4 animate-marquee"
          style={{ width: "max-content" }}
          data-testid="fleet-marquee"
        >
          {fleet.map((v, i) => (
            <article
              key={`${v.id}-${i}`}
              className="relative w-[220px] sm:w-[280px] lg:w-[360px] aspect-[4/5] flex-shrink-0 overflow-hidden group bg-[#FFC300] border border-[#1a1a1a]"
              data-testid={`vehicle-card-${v.id}-${i}`}
            >
              <img
                src={v.img}
                alt={v.name}
                loading="lazy"
                className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-700"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
              <div className="absolute bottom-0 left-0 right-0 p-5 translate-y-full group-hover:translate-y-0 transition-transform duration-500">
                <div className="flex items-center justify-between mb-1">
                  <span className="text-[10px] uppercase tracking-[0.25em] text-[#FFC300] font-bold">
                    {v.category}
                  </span>
                  <span className="inline-flex items-center gap-1.5 text-xs text-white font-semibold">
                    <Users className="w-3.5 h-3.5" /> {v.capacity}
                  </span>
                </div>
                <div className="font-display text-xl lg:text-2xl uppercase text-white font-black tracking-tight">
                  {v.name}
                </div>
                <p className="mt-1 text-xs text-neutral-300 leading-relaxed line-clamp-2">{v.desc}</p>
              </div>

              {/* Always-visible label strip on bottom */}
              <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black/90 via-black/60 to-transparent group-hover:opacity-0 transition-opacity duration-300">
                <div className="flex items-center justify-between">
                  <div>
                    <div className="text-[10px] uppercase tracking-[0.3em] text-[#FFC300] font-bold mb-1">
                      {v.category}
                    </div>
                    <div className="font-display text-lg lg:text-xl uppercase text-white font-black tracking-tight">
                      {v.name}
                    </div>
                  </div>
                  <span className="inline-flex items-center gap-1.5 text-xs text-white font-semibold bg-black/50 px-2 py-1">
                    <Users className="w-3.5 h-3.5" /> {v.capacity}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
